<template>
  <div class="sign-contract text-center">
    <h1 v-if="customer">Congratulations {{ customer.fname }}!</h1><br/>
    <h3>Welcome to Mission Pest Control. Probably the best decision you've made today. ;)</h3>
    <v-overlay :model-value="loading" persistent class="d-flex align-center justify-center">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>

        <v-btn color="primary"
          size="large"
          class="font-weight-bold ma-6"
          @click="createContract"
        >Agree & Sign</v-btn>

      <p>You're almost done! Please read through the service agreement and sign to make it official.</p><br/><br/>
      <img :src="require('@/assets/mission/mission-anteater.png')" alt="Mission Anteater" style="max-width: 400px; margin-bottom: 1rem;" />

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SignContract',
  data() {
    return {
        loading: false,
        subscription: {
          success: false,
          id: null,
        },
        customer: JSON.parse(localStorage.getItem("mission-customer")) || null,
        iframeURL: null,
        apiBaseUrl: process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000/api'  // Local server
        : 'https://api.getpestcontrol.services/api'  // Production server
    };
  },
  props: {
    receivedApppointment: Object,
    receivedBilling: Object,
  },
  watch: {
    receivedBilling: {
      handler(newValue) {
        console.log('receivedBilling changed:', newValue);
        this.subscription = newValue;
      },
      immediate: true, // Immediately run the handler upon mounting
      deep: true,      // enable deep watching if receivedPlace is a complex object
    },
    receivedApppointment: {
      handler(newValue) {
        console.log('receivedApppointment changed:', newValue);
      },
      immediate: true, // Immediately run the handler upon mounting
      deep: true,  // enable deep watching if receivedCustomer is a complex object
    },
  },
  methods: {
    submitSignature() {
      localStorage.setItem('mission-contract', this.signature);
      this.$emit('signed'); // Let parent know we're done
    },
    openContract() {
        window.open(this.iframeURL, '_blank');
    },
    async createContract() {
        this.loading = true;
        if(this.iframeURL) {
            this.openContract();
            this.loading = false;
            return;
        }
        try {
            const contractDetails = {
                customerID: this.customer.customerID || null,
                subscriptionID: this.subscription.id || null,
            }

            const response = await axios.post(`${this.apiBaseUrl}/contract/create`, contractDetails);
            console.log(response.data);

            if(response.data.success) {
                this.iframeURL = response.data.result;
                this.openContract();
            }

        } catch (error) {
            this.error = error.message;
            console.error("Error creating customer:", error);
        } finally {
            this.loading = false;
        }
    }
  },
  mounted() {
    // do a thing!
  }
};
</script>

<style scoped>
.sign-contract h1, h3 {
  color: var(--brand-primary);
}
img {
    border-radius: 10px;
}
</style>
